import TablesStore from './Tables';
import TableEditorStore from './TableEditor';

const Tables = new TablesStore();
const TableEditor = new TableEditorStore(Tables);

export default {
  Tables,
  TableEditor,
};